import {httpClient} from "../../../services/HttpClient";
import Project from "../../models/Project";
import Integration from "../../models/Integration";
import CrmClient from "../../models/CrmClient";
import CrmOrder from "../../models/CrmOrder";

export default {
    namespaced: true,
    state: {
        project: null,
        integration: null,
        crmClient: null,
        crmOrder: null,
        crmOrderStatus: null,
        crmOrderSource: null,
        crmOrderCustomField: null,
    },
    mutations: {
        setProject(state: any, project: Project) {
            state.project = project;
        },
        setIntegration(state: any, integration: Integration) {
            state.integration = integration;
        },
        setCrmClient(state: any, crmClient: CrmClient) {
            state.crmClient = crmClient;
        },
        setCrmOrder(state: any, crmOrder: CrmOrder) {
            state.crmOrder = crmOrder;
        },
        setCrmOrderStatus(state: any, crmOrderStatus: any) {
            state.crmOrderStatus = crmOrderStatus;
        },
        setCrmOrderSource(state: any, crmOrderSource: any) {
            state.crmOrderSource = crmOrderSource;
        },
        setCrmOrderCustomField(state: any, crmOrderCustomField: any) {
            state.crmOrderCustomField = crmOrderCustomField;
        },
    },
    actions: {
        async fetchProject({ commit }: any, projectUuid: string) {
            await httpClient.get('/projects/' + projectUuid).then(response => {
                let responseData = response.data.data;

                let project = new Project();

                project.id = responseData.id;
                project.uuid = responseData.uuid;
                project.name = responseData.name;
                project.alias = responseData.alias;
                project.tariff = responseData.tariff ?? null;

                commit('setProject', project);
            })
        },
        async fetchIntegration({ commit }: any, params: { projectUuid: string, integrationUuid: string }) {
            await httpClient.get(`/projects/${params.projectUuid}/pim/channels/${params.integrationUuid}`).then(response => {
                let responseData = response.data.data;

                let integration = new Integration(responseData);

                commit('setIntegration', integration);
            })
        },
        async fetchCrmClient({ commit }: any, params: { projectUuid: string, clientUuid: string }) {
            await httpClient.get(`/projects/${params.projectUuid}/crm/clients/${params.clientUuid}`).then((response: any) => {
                let responseData = response.data.data;

                let crmClient = new CrmClient(responseData);

                commit('setCrmClient', crmClient);
            })
        },
        async fetchCrmOrder({ commit }: any, params: { projectUuid: string, orderUuid: string }) {
            await httpClient.get(`/projects/${params.projectUuid}/crm/orders/${params.orderUuid}`).then((response: any) => {
                let responseData = response.data.data;

                let crmOrder = new CrmOrder(responseData);

                commit('setCrmOrder', crmOrder);
            })
        },
        async fetchCrmOrderStatus({ commit }: any, params: { projectUuid: string, orderStatusUuid: string }) {
            await httpClient.get(`/projects/${params.projectUuid}/crm/statuses/${params.orderStatusUuid}`).then((response: any) => {
                let responseData = response.data.data;

                commit('setCrmOrderStatus', responseData);
            })
        },
        async fetchCrmOrderSource({ commit }: any, params: { projectUuid: string, orderSourceUuid: string }) {
            await httpClient.get(`/projects/${params.projectUuid}/crm/sources/${params.orderSourceUuid}`).then((response: any) => {
                let responseData = response.data.data;

                commit('setCrmOrderSource', responseData);
            })
        },
        async fetchCrmOrderCustomField({ commit }: any, params: { projectUuid: string, orderCustomFieldUuid: string }) {
            await httpClient.get(`/projects/${params.projectUuid}/crm/custom-fields/${params.orderCustomFieldUuid}`).then((response: any) => {
                let responseData = response.data.data;

                commit('setCrmOrderCustomField', responseData);
            })
        },
    },
    getters: {
        project: (state: any) => state.project,
        integration: (state: any) => state.integration,
        crmClient: (state: any) => state.crmClient,
        crmOrder: (state: any) => state.crmOrder,
        crmOrderStatus: (state: any) => state.crmOrderStatus,
        crmOrderSource: (state: any) => state.crmOrderSource,
        crmOrderCustomField: (state: any) => state.crmOrderCustomField,
    },
}
